import VBtn from './VBtn.vue';

export { VBtn };
export default VBtn;
